import { useState } from 'react';
import { DatasetCreationEnum, DatasetStatus } from '~/api/types';
import { useGetDatasetEnumsQuery, useGetOperatingUnitsQuery } from '~/api/v2/hooks';
import { TableFilterType, allFilterOption } from '~/components/Table/components/filters/types';
import { DatasetFilters, DatasetFiltersType } from '~/pages/DataCatalogPage/components/DatasetsTable';

const useDatasetsFilters = () => {
  const [filters, setFilters] = useState<DatasetFilters>({
    [DatasetFiltersType.STATUS]: [],
    [DatasetFiltersType.OU_OWNER]: [],
    [DatasetFiltersType.ANATOMY]: [],
    [DatasetFiltersType.MODALITY]: [],
    [DatasetFiltersType.DATA_SOURCE_CATEGORY]: [],
    [DatasetFiltersType.DATA_SOURCE_TYPE]: [],
  });
  const { data: anatomyOptions } = useGetDatasetEnumsQuery({ enumKey: DatasetCreationEnum.ANATOMY });
  const { data: modalityOptions } = useGetDatasetEnumsQuery({ enumKey: DatasetCreationEnum.MODALITY });
  const { data: dataSourceCategoryOptions } = useGetDatasetEnumsQuery({
    enumKey: DatasetCreationEnum.COLLECTION_SOURCE,
  });
  const { data: dataSourceTypeOptions } = useGetDatasetEnumsQuery({ enumKey: DatasetCreationEnum.DATA_TYPE });
  const { data: ouOwnerOptions } = useGetOperatingUnitsQuery({});

  const filterOptions = [
    {
      id: DatasetFiltersType.STATUS,
      name: 'Dataset Status',
      type: TableFilterType.CHECKBOX,
      options: [
        allFilterOption,
        ...Object.values(DatasetStatus).map((status) => ({
          id: status,
          label: status,
        })),
      ],
    },
    {
      id: DatasetFiltersType.DATA_SOURCE_TYPE,
      name: 'Data Source Type',
      type: TableFilterType.AUTOCOMPLETE,
      options: dataSourceTypeOptions?.map(({ key, value }) => ({
        id: key,
        label: value,
      })),
    },
    {
      id: DatasetFiltersType.DATA_SOURCE_CATEGORY,
      name: 'Data Source Category',
      type: TableFilterType.MULTIPLE_AUTOCOMPLETE,
      options: dataSourceCategoryOptions?.map(({ key, value }) => ({
        id: key,
        label: value,
      })),
    },
    {
      id: DatasetFiltersType.OU_OWNER,
      name: 'OU Owner',
      type: TableFilterType.MULTIPLE_AUTOCOMPLETE,
      options: ouOwnerOptions?.map(({ id, description }) => ({
        id: `${id}`,
        label: description,
      })),
    },
    {
      id: DatasetFiltersType.ANATOMY,
      name: 'Anatomy',
      type: TableFilterType.CHECKBOX,
      options: [
        allFilterOption,
        ...(anatomyOptions?.map(({ key, value }) => ({
          id: key,
          label: value,
        })) ?? []),
      ],
    },
    {
      id: DatasetFiltersType.MODALITY,
      name: 'Modality',
      type: TableFilterType.CHECKBOX,
      options: [
        allFilterOption,
        ...(modalityOptions?.map(({ key, value }) => ({
          id: key,
          label: value,
        })) ?? []),
      ],
    },
  ];

  return { filterOptions, filters, setFilters };
};

export default useDatasetsFilters;
